import { Component } from '@angular/core';

@Component({
  selector: 'app-login-right-panel',
  templateUrl: './login-right-panel.component.html',
  styleUrls: ['./login-right-panel.component.scss']
})
export class LoginRightPanelComponent {
}
